import { getImgSrc, getPathUrl } from "../../../function";
import { useRef, useState } from "react";
import api from "../../../api";
import { Storage } from "aws-amplify";

const UPLOAD_ICON = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9701 1H18.0301C16.7601 1 16.0001 1.76 16.0001 3.03V5.97C16.0001 7.24 16.7601 8 18.0301 8H20.9701C22.2401 8 23.0001 7.24 23.0001 5.97V3.03C23.0001 1.76 22.2401 1 20.9701 1ZM21.1901 4.31C21.0701 4.43 20.9101 4.49 20.7501 4.49C20.5901 4.49 20.4301 4.43 20.3101 4.31L20.1301 4.13V6.37C20.1301 6.72 19.8501 7 19.5001 7C19.1501 7 18.8701 6.72 18.8701 6.37V4.13L18.6901 4.31C18.4501 4.55 18.0501 4.55 17.8101 4.31C17.5701 4.07 17.5701 3.67 17.8101 3.43L19.0601 2.18C19.1101 2.13 19.1801 2.09 19.2501 2.06C19.2701 2.05 19.2901 2.05 19.3101 2.04C19.3601 2.02 19.4101 2.01 19.4701 2.01H19.5301C19.6001 2.01 19.6601 2.02 19.7301 2.05H19.7501C19.8201 2.08 19.8801 2.12 19.9301 2.17C19.9401 2.18 19.9401 2.18 19.9501 2.18L21.2001 3.43C21.4401 3.67 21.4401 4.07 21.1901 4.31ZM9.00012 10.38C9.63133 10.38 10.2367 10.1293 10.683 9.68291C11.1294 9.23658 11.3801 8.63122 11.3801 8C11.3801 7.36878 11.1294 6.76342 10.683 6.31709C10.2367 5.87075 9.63133 5.62 9.00012 5.62C8.3689 5.62 7.76354 5.87075 7.3172 6.31709C6.87087 6.76342 6.62012 7.36878 6.62012 8C6.62012 8.63122 6.87087 9.23658 7.3172 9.68291C7.76354 10.1293 8.3689 10.38 9.00012 10.38Z"
        fill="#12BABD"
      />
      <path
        d="M20.97 8H20.5V12.61L20.37 12.5C19.59 11.83 18.33 11.83 17.55 12.5L13.39 16.07C12.61 16.74 11.35 16.74 10.57 16.07L10.23 15.79C9.52 15.17 8.39 15.11 7.59 15.65L3.85 18.16C3.63 17.6 3.5 16.95 3.5 16.19V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16V3.03C16 2.63 16.07 2.29 16.23 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 17.28 2.19 18.23 2.56 19.03C3.42 20.93 5.26 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.77C21.71 7.93 21.37 8 20.97 8Z"
        fill="#12BABD"
      />
    </svg>
  );
};

const DELETE_ICON = ({ className }) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="#CFFEFF" />
      <path
        d="M17.5714 16V13.8C17.5714 13.3226 17.752 12.8648 18.0735 12.5272C18.395 12.1896 18.8311 12 19.2857 12H22.7143C23.1689 12 23.605 12.1896 23.9265 12.5272C24.248 12.8648 24.4286 13.3226 24.4286 13.8V16M13 16H29M19 20V25M23 20V25M28 16L27 28.2C27 28.6774 26.8194 29.1352 26.4979 29.4728C26.1764 29.8104 25.7404 30 25.2857 30H16.7143C16.2596 30 15.8236 29.8104 15.5021 29.4728C15.1806 29.1352 15 28.6774 15 28.2L14 16H28Z"
        stroke="#12BABD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const SponserForm = ({ sponser, reloadData = () => {} }) => {
  const [form, setForm] = useState(sponser);
  const inputRef = useRef(null);

  const handlePhotoUpload = (e) => {
    setForm({
      ...form,
      sponser_image: e.target.files[0],
    });
  };

  const updateSponser = async () => {
    const formData = {
      ...form,
    };

    const uploadSponserImage = form.sponser_image.name;
    if (uploadSponserImage) {
      const keyUpload = `${new Date().getTime()}`;
      await Storage.put(keyUpload, form.sponser_image);
      formData.sponser_image = keyUpload;
    }

    const { data } = await api.put(`/sponsers2/${form._id}`, formData);
    reloadData();
  };

  const deleteSponser = async () => {
    console.log("form._id", form._id);
    await api.delete(`/sponsers2/${form._id}`);
    reloadData();
  };

  return (
    <div className="flex flex-col items-center justify-center w-[300px] h-[400px] border border-gray-600 rounded-2xl space-y-4 py-4">
      <input
        //   disabled={isView}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          handlePhotoUpload(e);
        }}
        ref={inputRef}
        accept="image/*, video/*"
      />

      <div className="relative">
        <div>
          {form.sponser_image !== "" && (
            <img
              src={getImgSrc(form.sponser_image)}
              alt="Sponser"
              className="w-[200px]  h-[200px] object-cover rounded-lg shadow-lg mb-4"
            />
          )}
        </div>
        {form.sponser_image !== "" && (
          <div
            className="absolute right-2 top-2   cursor-pointer  w-[42px] h-[42px] flex items-center justify-center "
            onClick={() => {
              setForm({
                ...form,
                sponser_image: "",
              });
            }}
          >
            <DELETE_ICON />
          </div>
        )}
      </div>

      {form.sponser_image === "" && (
        <div
          className="w-full h-full rounded flex flex-col items-center justify-center p-2 hover:bg-slate-50 duration-200 cursor-pointer "
          onClick={() => {
            inputRef.current.click();
          }}
        >
          <UPLOAD_ICON />
          <div className="text-xs text-teal-400">UploadPhoto</div>
        </div>
      )}

      <div>
        <div>Link</div>
        <input
          type="text"
          placeholder="Sponser Link"
          value={form.sponser_link}
          onChange={(e) => {
            setForm({
              ...form,
              sponser_link: e.target.value,
            });
          }}
          className="w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div className="flex space-x-4">
        <div
          className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 cursor-pointer"
          onClick={updateSponser}
        >
          <span>Save</span>
        </div>
        <div
          className="bg-red-500 text-white px-4 py-2 rounded-lg shadow hover:bg-red-600 cursor-pointer"
          onClick={deleteSponser}
        >
          <span>Delete</span>
        </div>
      </div>
    </div>
  );
};

export default SponserForm;
